import { FileComponentProps } from "../../types";
import { FilePreviewWrapper } from "../FilePreviewWrapper";

import { VideoThumbnail } from "./VideoThumbnail";
import { VideoPlayer } from "./VideoPlayer";

export const VideoDisplay = ({
  data,
  detectedFile,
  isViewing,
  setIsViewing,
}: FileComponentProps) => {
  let cleanData = data;
  if (cleanData.startsWith("[") && cleanData.endsWith("]")) {
    try {
      const parsed = JSON.parse(cleanData);
      if (Array.isArray(parsed) && parsed.length > 0) {
        cleanData = parsed[0];
      }
    } catch {
      cleanData = cleanData.slice(1, -1).replace(/"/g, "");
    }
  }

  cleanData = cleanData.replace(/^"(.*)"$/, "$1");

  const dataUrl = cleanData.startsWith("data:")
    ? cleanData.replace(/data:video\/[^;]+/, "data:video/mp4")
    : `data:video/mp4;base64,${cleanData}`;

  return (
    <div className="group relative">
      <div className="cursor-pointer rounded p-2 transition-colors hover:bg-gray-100">
        <FilePreviewWrapper
          isViewing={isViewing}
          setIsViewing={setIsViewing}
          trigger={
            <div>
              <VideoThumbnail detectedFile={detectedFile} data={data} />
            </div>
          }
        >
          <VideoPlayer dataUrl={dataUrl} />
        </FilePreviewWrapper>
      </div>
    </div>
  );
};
